// extracted by mini-css-extract-plugin
export default {"certificatesSection":"Certificates_certificatesSection__kAm3W","certificate":"Certificates_certificate__V8JLN"};